import { CourseModal } from './CourseModal';

export default CourseModal;
